import client from '/src/services/client.js';

export default {
    getPoles: () => client.get('admin/poles'),
    createPole: (data) => client.post('admin/poles', data),
    updatePole: (id, data) => client.put(`admin/poles/${id}`, data),
    deletePole: (id) => client.delete(`admin/poles/${id}`),
}
